import { capitalizeWords } from '../misc';
import { LOCAL_STORAGE } from '../../constants';
import { getLocalStorageItem } from '../localStorage'

export const manufacturingDataCompiler = (data) => {
  let finalData = [];
  data?.length &&
    data.forEach((obj) => {
      let mfgData = {
        data: obj,
        url: obj?.future_lot,
        lot_no: obj?.future_lot,
        SKU:
          obj?.dyeing_product_id?.default_code ||
          obj?.dyeing_product_id?.display_name ||
          obj?.product_id?.default_code ||
          obj?.product_id?.display_name,
        total_qty: obj?.product_uom_qty,
        priority: capitalizeWords(obj?.manufacture_priority),
        batch: obj?.batch_ids,
        id: obj?.id,
        product_id: obj?.product_id?.id,
        display_name: obj?.product_id?.display_name,
        ready_qty: obj?.produced_qty,
        qty_status:
          obj?.produced_qty === 0
            ? 'Pending'
            : obj?.produced_qty < obj?.product_uom_qty
              ? 'Partial'
              : 'Completed',
        qty_status_list:
          obj?.produced_qty === 0
            ? 'Pending'
            : obj?.produced_qty < obj?.product_uom_qty
              ? 'Partial'
              : 'Done',
        ready_status: capitalizeWords(obj?.ready_status),
        finished_product:
          obj?.dyeing_product_id?.display_name || obj?.product_id?.display_name || 'N/A',
      };
      finalData.push(mfgData);
    });
  return finalData;
};

export function fabricManufacturingProductCompiler(data = []) {
  let finalData = [];
  const vendor_shipment = data.vendor_shipment;
  const vendorType = getLocalStorageItem(LOCAL_STORAGE.VENDOR_TYPE);
  const isDyeing = vendorType === 'dyeing';
  data.move_ids.forEach((obj) => {
    let lotno = null;

    if (vendor_shipment) {
      lotno = obj?.move_line_ids?.[0]?.lot_id?.name;
    } else {
      lotno = obj?.move_line_ids?.[0]?.lot_name;

      if (!lotno ) {
        lotno = obj?.future_lot;
      }
    }

    let dispatchProductsData = {
      move_id: obj.id,
      rolls: obj.no_of_rolls,
      vendor_shipment,
      lotno,
      demand_quantity: obj.product_uom_qty,
      producing_quantity: obj.produced_qty,
      draft_produced_qty : obj?.draft_produced_qty || 0,
      tracking: obj?.product_id?.tracking,
      unit: obj.product_uom?.name,
      product: isDyeing ? obj.product_id?.display_name : obj.product_id?.name,
      data: obj,
      state: obj.state,
      damaged_quantity: obj?.damage_qty,
      manufacture_damage_qty: obj?.manufacture_damage_qty || 'N/A',
      draft_damaged_qty : obj?.draft_damaged_qty || 0,
      total_damaged_quantity: obj?.total_damage_qty,
      ready_status: capitalizeWords(obj?.ready_status.replace('_', ' ')),
      color: obj?.product_id?.variant_color || 'N/A',
      size: obj?.product_id?.variant_size || 'N/A',
      force_consumption: obj?.product_id?.force_consumption,
    };
    finalData.push(dispatchProductsData);
  });
  return finalData;
}

export const batchDataCompiler = (obj) => {
  let finalData = {
    product_id: obj.product_id.id,
    batch: obj.batch_ids,
    lotData: obj,
    lots: obj?.lots,
    selected_lot: obj?.selected_lot,
    batch_qty: obj?.batch_ids?.reduce((acc, cum) => (acc += cum.order_qty), 0),
    // material:
    //   obj.move_ids.filter((move) => move.state === 'assigned')[0]?.material_available ||
    //   obj.move_ids[0].material_available,
    SKU: obj.product_id.default_code,
    lot_no: obj.future_lot,
    total_qty: obj.product_uom_qty,
    ready_qty: obj.produced_qty,
    move_id: obj.move_ids.filter((move) => move.state === 'assigned')[0]?.id || obj.move_ids[0].id,
    dyeing: obj.product_id.dyeing_type === 'dyeing',
    priority: obj.manufacture_priority,
    remaining_qty: obj?.remaining_qty,
    total_cut_qty: obj?.total_cut_qty,
    total_sew_qty: obj?.total_sew_qty,
    total_damage_qty: obj?.total_damage_qty,
    ready_status: capitalizeWords(obj?.ready_status.replace('_', ' ')),
    not_ready_lots: obj?.raw_material_product,
  };
  return finalData;
};
